module.exports = __webpack_public_path__ + "bm.9c3ed536369843541995.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bm.svg
// module chunks = styles